import { render } from "./ImageBox.vue?vue&type=template&id=00db79b7&scoped=true"
import script from "./ImageBox.vue?vue&type=script&lang=js"
export * from "./ImageBox.vue?vue&type=script&lang=js"

import "./ImageBox.vue?vue&type=style&index=0&id=00db79b7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00db79b7"]])

export default __exports__